import { quickLinks } from './quickLinks.data';
export { quickLinks };
